import SpecificTemplate from './SpecificTemplate';

export default SpecificTemplate;
